import React from "react"
import styles from "../../../styles/contactUs.module.scss"
import "slick-carousel/slick/slick-theme.css"
import "slick-carousel/slick/slick.css"
import Linkedin from "../../../assets/linkedin.svg"
import Footer from "../../footer/footer"
import Layout from "../../Layout/Layout"
import Slide from "react-reveal/Slide"
import MapContainer from "../../map/map"
import ContactForm from "../../ContactUs/ContactForm"
import tt from "../../../helpers/translation"

const ContactPage = ({ lang, seoData, urls, pageContext }) => {
  return (
    <Layout
      leftContactUs
      lan={lang}
      location="contact-us"
      contrast={true}
      seoData={seoData}
      urls={urls}
      noFooter
    >
      <div>
        <div className={styles.white_section_container}>
          <div className={styles.text_container}>
            <h1>{tt("Contact us", lang)}</h1>
            <p className={styles.subtitle}>
              {tt("Start your project, we are here to help you!", lang)}
            </p>
            <p className={styles.adress}>
              C/ Roger de Llúria, 118 3er 1a - 08037 BARCELONA
              <br />
            </p>
            <div className={styles.contact_links}>
              <a href="mailto:hola@interficie.com">hola@interficie.com</a>
              <a
                href="https://www.linkedin.com/company/interficie-proyectos-interactivos"
                target="blank"
              >
                <Linkedin />
              </a>
            </div>
          </div>
        </div>
        <div className={styles.map_container}>
          <MapContainer />
        </div>
        <ContactForm pageContext={pageContext} lang={lang} />
        <Footer lang={lang} />
      </div>
    </Layout>
  )
}

export default ContactPage
